import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useCreateAudioPostMutation = createMutationHook(
  MembershipsCreatorApiClient.createAudioPost,
  {
    mutationKey: ['createAudioPost'],
  },
)
